module.exports = __webpack_public_path__ + "static/media/custom_button.f60206e3.svg";